module.exports = __webpack_public_path__ + "aebec71eb94fc305bee614619cbb0a9a.svg";